import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { CashbackFormData } from '@features/cashback/types';
import { CashBackMembership, LoyaltyProgram } from '@rd/types';
import { RedeemCashV2WrapperComponentDirective } from '../../redeem-cash-v2-wrapper.component';

@Component({
  selector: 'rd-rcv2-checkout-form-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RcV2CheckoutFormWrapperComponent extends RedeemCashV2WrapperComponentDirective {
  @HostBinding('class.rd-rcv2-checkout-form-wrapper') componentClass = true;

  @Input() disabled = false;
  @Input() formData: CashbackFormData;
  @Input() isLoggedIn: boolean;
  @Input() redeemCashLoyaltyProgram: LoyaltyProgram;
  @Input() redeemCashMembership: CashBackMembership;
  @Input() loading: boolean;
  @Output() submitForm = new EventEmitter<CashbackFormData>();

  componentName = 'rcv2-checkout-form';
}
